import { getDateTimeFromISOString } from "./CommonFunc";

function DiaryHeader(props) {
	const [date, time] = getDateTimeFromISOString(
		props.currentDiary?.DATE_CREATE
	);
	return (
		<div className='header'>
			{false && props.currentDiary?.MNEMO ? (
				<>
					<div className='title'>{props.currentDiary?.MNEMO ?? ""}</div>
					<div className='info'>
						<div>Дата создания: {date ?? "-"}</div>
						<div>Время создания: {time ?? "-"}</div>
					</div>
				</>
			) : null}
		</div>
	);
}

export default DiaryHeader;
